import { ChatAgent } from './ChatAgent';

export type AgentManagerConfig = {
  /** Maximum number of active conversations before garbage collection triggers */
  maxActiveConversations?: number;
  /** Enable LRU-based garbage collection of old conversations */
  enableGarbageCollection?: boolean;
};

/**
 * @desc Manages multiple ChatAgent instances and coordinates conversation streams.
 * Handles activation, deactivation, and optional LRU-based garbage collection.
 */
export class AgentManager {
  private readonly _instanceId = Math.random().toString(36).substring(7);

  // map remote id to any local ephemeral id -> {conversationId}:{uid}
  private agentLookup = new Map<string, string>();
  // map of {uid|conversationId}:{agent}
  private agents = new Map<string, ChatAgent>();

  getAgent(conversationId: string): ChatAgent {
    const id = this.agentLookup.get(conversationId) ?? conversationId;
    let agent = this.agents.get(id);
    if (agent) return agent;
    agent = new ChatAgent(conversationId, this);
    this.agents.set(agent.id, agent);
    return agent;
  }

  setAgentLookup(uid: string, conversationId: string) {
    this.agentLookup.set(conversationId, uid);
  }

  constructor(readonly config?: AgentManagerConfig) {
    // console.debug('[AgentManager] constructor', { instanceId: this._instanceId });
  }

  /**
   * @desc Deactivate a conversation, destroying its ChatAgent.
   */
  clearAgent(conversationId: string) {
    const agent = this.getAgent(conversationId);
    agent.teardown();
    this.agents.delete(agent.id);
  }

  /**
   * @desc Check if a conversation is currently active.
   */
  isActive(conversationId: string): boolean {
    return this.agents.has(conversationId);
  }

  /**
   * @desc Perform LRU garbage collection by evicting the least recently updated conversation.
   *  todo: add back garbage collector later on
   *
   */
  // private performGarbageCollection() {
  //   let oldestId: string | null = null;
  //   let oldestTime = Infinity;
  //
  //   // Find conversation with smallest updatedAt (least recently updated)
  //   for (const [id, meta] of this.metadata.entries()) {
  //     if (meta.updatedAt < oldestTime) {
  //       oldestTime = meta.updatedAt;
  //       oldestId = id;
  //     }
  //   }
  //
  //   if (oldestId) {
  //     this.clearAgent(oldestId);
  //   }
  // }
}
